export default "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAIAAACQd1PeAAAAAXNSR0IArs4c6QAAAAxJREFUCJlj+P//PwAF/gL+WPJrDgAAAABJRU5ErkJggg=="